import React from "react";
import { Snackbar as MUISnackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const Snackbar = ({ message = "", isOpen = false, toggle }) => {
    const handleClose = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
        toggle();
    };

    return (
        <MUISnackbar
            open={isOpen}
            onClose={handleClose}
            autoHideDuration={8000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
            <Alert severity="error">{message}</Alert>
        </MUISnackbar>
    );
};
